import { ProductTileFeature } from "@omni/types/api/product/bff/shared/productTileFeature.model";
import classnames from "classnames";

import "./description.scss";

import { renderFeature } from "./description.helpers";

export type ProductTileDescriptionProps = {
    items?: ProductTileFeature[];
    showItems: boolean;
    amountOfFeatures: number;
    className?: string;
};

const ProductTileDescription = ({
    items,
    showItems,
    amountOfFeatures,
    className
}: ProductTileDescriptionProps) => {
    return (
        <div className={classnames("product-layout-description", className)}>
            {items && showItems && (
                <ul className="product-layout-description__list">
                    {items.slice(0, amountOfFeatures).map((feature, key) => (
                        <li
                            key={key}
                            className={"w-100"}
                        >
                            <span className={"pr-2 text-primary"}>
                                &#x25A0;
                            </span>
                            {feature.name}:{" "}
                            {renderFeature({
                                formattedValues: feature.featureValues.map(
                                    (f) => f.formattedValue || ""
                                ),
                                unitName: feature.unit?.name || null
                            })}
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
};

export { ProductTileDescription };
